import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import {Translate} from "react-localize-redux";


const noteStyles = theme => {
    return {
        noteP: {
            margin: '0 0 5px 0'
        },
        invalidToken: {
            textAlign: 'center'
        }
    }
};

class InvalidTokenNote extends Component {
    render () {
        let {classes, actionClick} = this.props;
        return (
            <div className='b-reset-password__item'>
                <div className='b-reset-password__note'>
                    <div className='b-reset-password__note_header'>
                        <Typography variant='h5' component='h3'>
                            <Translate id='passwordResetLinkHasExpired' />
                        </Typography>
                    </div>
                    <div className={`${classes.invalidToken} b-reset-password__note_body`}>
                        <Typography component='p' className={classes.noteP}>
                            <Translate id='toResetPasswordAgainClickLink' />
                        </Typography>
                    </div>
                    <div className='b-reset-password__note_controls'>
                        <Button href='#/reset-password' color='primary' onClick={actionClick}><Translate id='login.form.restore.password' /></Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withStyles(noteStyles)(InvalidTokenNote);